export const SAMPLE_CODE = 'sampleCode';
export const DATE_OF_BIRTH = 'dOB';
export const CONSENT = 'consent';
